import { render, staticRenderFns } from "./PartnerData.vue?vue&type=template&id=0ee6e41e&scoped=true"
import script from "./PartnerData.vue?vue&type=script&lang=js"
export * from "./PartnerData.vue?vue&type=script&lang=js"
import style0 from "./PartnerData.vue?vue&type=style&index=0&id=0ee6e41e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee6e41e",
  null
  
)

export default component.exports